export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./eventsVideo.vue?vue&type=template&id=01c9b39c&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/eventsVideo.vue?vue&type=template&id=01c9b39c&
// module id = 1619
// module chunks = 0